import type { CheckoutPriceOverviewItem, CheckoutPriceOverviewSubItems } from '../../domain/types/priceOverview'
import { Typography } from '@sunwebgroup/uds-ui/typography'
import cn from 'classnames'
import * as React from 'react'
import styles from './BreakDownTable.module.css'

export function BreakDownTable(props: { items: CheckoutPriceOverviewItem[] }) {
  const { items } = props

  return (
    <div className={styles.breakDownTableBox}>
      {items?.map((item, idx) => (
        <div key={`break-down-item${idx}`} className={styles.itemBox}>
          <div className={cn(styles.itemContent, item.total && styles.total)}>
            <Typography
              className={cn(styles.itemText, item.isDiscount && styles.discount)}
              variant={item.total ? 'body-l-bold-snug' : 'body-m-regular-snug'}
            >
              {item.concept || ''}
            </Typography>
            <Typography
              className={cn(styles.price, styles.itemText, item.isDiscount && styles.discount)}
              variant={item.total ? 'body-l-bold-snug' : 'body-m-bold-snug'}
            >
              {item.value || ''}
            </Typography>
          </div>

          {item.subitems?.map((subitem) => {
            return (
              <React.Fragment key={`break-down-item${idx}-${subitem.concept}`}>
                {SubItem(subitem, item.isDiscount)}
                {subitem.subitems && subitem.subitems.length > 0 && (
                  <div>{subitem.subitems.map(child => SubItem(child))}</div>
                )}
              </React.Fragment>
            )
          })}
        </div>
      ))}
    </div>
  )
}

function SubItem(subitem: CheckoutPriceOverviewSubItems, isDiscount?: boolean) {
  const { value, concept } = subitem

  return (
    <div className={styles.subItemContent}>
      <Typography className={cn(styles.subItemText, isDiscount && styles.discount)} variant="body-m-regular-snug">
        {concept}
      </Typography>
      <Typography className={cn(styles.price, styles.subItemPrice, isDiscount && styles.discount)} variant="body-m-bold-snug">
        {value || ''}
      </Typography>
    </div>
  )
}
